(function() {
  var Service,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.Machinery = (function(superClass) {
    var __reNest, __typeToRoute, __unNest;

    extend(Machinery, superClass);

    function Machinery(resource, http, rootScope) {
      this.resource = resource;
      this.http = http;
      this.rootScope = rootScope;
      this.Machinery = this.resource('backend/grower/machinery/:type/:id', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      this.Type = this.resource('backend/grower/machinery/types/:id');
      this.Subtype = this.resource('backend/grower/machinery/types/:typeId/subtypes/:id');
      this.Make = this.resource('backend/grower/machinery/types/:typeId/subtypes/:subtypeId/makes/:id', null, {
        validateUniqueName: {
          method: 'POST',
          url: 'backend/grower/machinery/types/:typeId/subtypes/:subtypeId/makes/validate-unique-name'
        }
      });
      this.Model = this.resource('backend/grower/machinery/types/:typeId/subtypes/:subtypeId/makes/:makeId/models/:id', null, {
        validateUniqueName: {
          method: 'POST',
          url: 'backend/grower/machinery/types/:typeId/subtypes/:subtypeId/makes/:makeId/models/validate-unique-name'
        }
      });
      this.ControllerMake = this.resource('backend/grower/machinery/controller-makes/:id');
      this.ControllerModel = this.resource('backend/grower/machinery/controller-makes/:makeId/controller-models/:id');
      this.RxNamingFormat = this.resource('backend/grower/machinery/controller-makes/:makeId/controller-models/:modelId/rx-naming-format/:id');
      this.RowSpacing = this.resource('backend/grower/machinery/row-spacings/:id', null, {
        validateWidth: {
          method: 'POST',
          url: 'backend/grower/machinery/row-spacings/validate-width'
        }
      });
    }

    __unNest = function(machine) {
      var ref;
      machine.controller_make = (ref = machine.controller_model) != null ? ref.make : void 0;
      return machine;
    };

    __reNest = function(machine) {
      var ref;
      if ((ref = machine.controller_model) != null) {
        ref.make = machine.controller_make;
      }
      return machine;
    };

    __typeToRoute = function(type) {
      if (type.name === 'Tillage') {
        return 'tillers';
      } else {
        return type.name.toLowerCase() + 's';
      }
    };

    Machinery.prototype.getMachinery = function(type, id) {
      var typeName;
      if (id == null) {
        id = null;
      }
      typeName = __typeToRoute(type);
      if (id != null) {
        return this.Machinery.get({
          type: typeName,
          id: id
        }).$promise.then(__unNest);
      } else {
        return this.Machinery.query({
          type: typeName
        }).$promise.then(function(machinery) {
          var i, len, machine;
          for (i = 0, len = machinery.length; i < len; i++) {
            machine = machinery[i];
            __unNest(machine);
          }
          return machinery;
        });
      }
    };

    Machinery.prototype.getTypes = function() {
      return this.Type.query().$promise;
    };

    Machinery.prototype.getType = function(id) {
      return this.Type.get({
        id: id
      }).$promise;
    };

    Machinery.prototype.getSubtypes = function(type) {
      return this.Subtype.query({
        typeId: type.id
      }).$promise;
    };

    Machinery.prototype.getSubtype = function(type, id) {
      return this.Subtype.get({
        typeId: type.id,
        id: id
      }).$promise;
    };

    Machinery.prototype.getMakes = function(type, subtype) {
      return this.Make.query({
        typeId: type.id,
        subtypeId: subtype.id
      }).$promise;
    };

    Machinery.prototype.getMake = function(type, subtype, id) {
      return this.Make.get({
        typeId: type.id,
        subtypeId: subtype.id,
        id: id
      }).$promise;
    };

    Machinery.prototype.getModels = function(type, subtype, make) {
      return this.Model.query({
        typeId: type.id,
        subtypeId: subtype.id,
        makeId: make.id
      }).$promise;
    };

    Machinery.prototype.getModel = function(type, subtype, make, id) {
      return this.Model.get({
        typeId: type.id,
        subtypeId: subtype.id,
        makeId: make.id,
        id: id
      }).$promise;
    };

    Machinery.prototype.getControllerMakes = function() {
      return this.ControllerMake.query().$promise;
    };

    Machinery.prototype.getControllerMake = function(id) {
      return this.ControllerMake.get({
        id: id
      }).$promise;
    };

    Machinery.prototype.getControllerModels = function(make) {
      return this.ControllerModel.query({
        makeId: make.id,
        hasFormats: true
      }).$promise;
    };

    Machinery.prototype.getControllerModel = function(make, id) {
      return this.ControllerModel.get({
        makeId: make.id,
        id: id
      }).$promise;
    };

    Machinery.prototype.getProprietaryFormats = function(make, model) {
      return this.RxNamingFormat.query({
        makeId: make.id,
        modelId: model.id
      }).$promise;
    };

    Machinery.prototype.getProprietaryFormat = function(make, model, id) {
      return this.RxNamingFormat.get({
        makeId: make.id,
        modelId: model.id,
        id: id
      }).$promise;
    };

    Machinery.prototype.getFormData = function(machinery) {
      return this.getMachinery(machinery.type, 'form');
    };

    Machinery.prototype.getPermissions = function() {
      return this.http.get('backend/grower/machinery/permissions').then(function(result) {
        return result.data;
      });
    };

    Machinery.prototype["new"] = function(data) {
      return new this.Machinery(data);
    };

    Machinery.prototype.save = function(machinery) {
      var type;
      type = __typeToRoute(machinery.type);
      __reNest(machinery);
      if (machinery.id != null) {
        return machinery.$update({
          type: type,
          id: machinery.id
        }).then(__unNest);
      }
      return machinery.$save({
        type: type
      }).then(__unNest);
    };

    Machinery.prototype["delete"] = function(machinery) {
      var type;
      type = __typeToRoute(machinery.type);
      return machinery.$delete({
        type: type
      });
    };

    Machinery.prototype.saveMake = function(make) {
      return make.$save({
        typeId: make.subtype.type.id,
        subtypeId: make.subtype.id
      });
    };

    Machinery.prototype.saveModel = function(model) {
      return model.$save({
        typeId: model.make.subtype.type.id,
        subtypeId: model.make.subtype.id,
        makeId: model.make.id
      });
    };

    Machinery.prototype.requestController = function(make, model) {
      return this.http.post('backend/grower/machinery/request-controller', {
        make: make.name,
        model: model.name
      }).then(function(result) {
        return result.data;
      });
    };

    Machinery.prototype.createRowSpacing = function(rowSpacing) {
      return rowSpacing.$save();
    };

    Machinery.prototype.validateNickname = function(machine, name) {
      return this.http.post('backend/grower/machinery/validate-nickname', {
        nickname: name,
        type: machine.type.name,
        id: machine.id
      });
    };

    Machinery.prototype.validateMake = function(type, subtype, name) {
      return this.Make.validateUniqueName({
        typeId: type.id,
        subtypeId: subtype.id
      }, {
        name: name
      }).$promise;
    };

    Machinery.prototype.validateModel = function(type, subtype, make, name) {
      return this.Model.validateUniqueName({
        typeId: type.id,
        subtypeId: subtype.id,
        makeId: make.id
      }, {
        name: name
      }).$promise;
    };

    Machinery.prototype.validateRowSpacing = function(width) {
      return this.RowSpacing.validateWidth({
        width: width
      }).$promise;
    };

    return Machinery;

  })(Service);

}).call(this);
